import React from "react";

import { Container } from "react-bootstrap";
import { useRouter } from "next/router";
import { FormattedMessage } from "react-intl";
import dynamic from "next/dynamic";
import Image from "next/future/image";
import Vector1 from "../../assets/images/Vector1.png";
import Vector2 from "../../assets/images/Vector2.png";
import { buildApiUrl } from "src/helpers/imageHelpers";

const PageHeader = dynamic(
  () => import("src/components/shared/PageHeader/PageHeader"),
);
const AboutParallelogram = dynamic(
  () =>
    import("src/components/AboutPage/AboutParallelogram/AboutParallelogram"),
);
const Spliter = dynamic(() => import("src/components/HomePage/Spliter/Spliter"));

const CommonQuestions = dynamic(
  () => import("src/components/shared/CommonQuestions/CommonQuestions"),
);
const Footer = dynamic(() => import("src/components/shared/Footer/Footer.jsx"));

import styles from "./AboutPage.module.scss";
import BreadCrumb from "src/components/shared/breadCrumb/Index";

const AboutPage = ({ data }) => {
  const {
    statistics,
    questions,
    advantages,
    about_us,
    information,
  } = data;
  const aboutUsData = about_us?.[0]?.categories?.[0]?.posts?.[0]?.data;
  const advantagesData = advantages?.[0]?.categories?.[0]?.posts;
  const statisticsData = statistics?.[0]?.categories?.[0]?.posts;
  const questionsData = questions?.[0]?.categories?.[0]?.posts;
  const informationData = information?.[0]?.categories?.[0]?.posts?.[0].data;
  // =========================================================
  const statisticsSection = statisticsData?.find(
    (question) => question.id === 417,
  );
  const statisticsSectionBackgroundImage = statisticsSection?.data?.image;
  const filteredStatistics = statisticsData?.filter(
    (question) => question.id !== 417,
  );
  // =========================================================

  const targetQuestion = questionsData?.find((question) => question.id === 415);
  const commonQuestionsBackgroundImage = targetQuestion?.data?.image;
  const filteredQuestions = questionsData?.filter(
    (question) => question.id !== 415,
  );

  // =========================================================

  const router = useRouter();
  const { locale: lang } = router;

  return (
    <>
      <PageHeader />
      <BreadCrumb title={<FormattedMessage id="about" />} />
      <section className={styles["about-section"]}>
        <div>
          {data?.about_us?.length > 0 && (
            <AboutParallelogram
              backgroundPath={`${
                aboutUsData?.image
                  ? process.env.NEXT_PUBLIC_API_URL + aboutUsData?.image
                  : ""
              }`}
              withButton={false}
              primaryText={aboutUsData?.title[lang]}
              secondaryText={aboutUsData?.description?.[lang]}
              imageMeta={aboutUsData?.imageMeta}
              onClickButtonFunction={() => router.push("/ourworks")}
            />
          )}
        </div>

       
        {advantagesData?.length > 0 && (
          <div className={styles["advantages-section"]}>
            <Container>
              <div className={styles["advantages-header"]}>
                <h2>
                  <FormattedMessage id="why-choose" />
                </h2>
                <span>MU7</span>
              </div>

              <div
                className={`${styles["advantages-timeline"]} ${
                  lang === "ar" ? styles.rtl : ""
                }`}
                dir={lang === "ar" ? "rtl" : "ltr"}
              >
                {advantagesData?.map((post, index) => {
                  const arrowImage = index % 2 === 0 ? Vector1 : Vector2;

                  return (
                    <React.Fragment key={post?.id || index}>
                      <div className={styles["advantage-item"]}>
                        <div className={styles["advantage-icon"]}>
                          <Image
                            src={buildApiUrl(post?.data?.image)}
                            alt={post?.data?.title?.[lang] || "advantage-icon"}
                            width={58}
                            height={58}
                            priority={index < 2}
                          />
                        </div>

                        <h3>{post?.data?.title?.[lang]}</h3>
                        <p>{post?.data?.description?.[lang]}</p>
                      </div>

                      {index < advantagesData.length - 1 && (
                        <div className={styles["advantage-arrow"]}>
                          <Image
                            src={arrowImage}
                            alt="timeline-arrow"
                            width={82}
                            height={24}
                          />
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </Container>
          </div>
        )}
         <Spliter
          primaryTitle={informationData?.firstTitle?.[lang]}
          primaryHtml={informationData?.firstDescription?.[lang]}
          secondaryTitle={informationData?.secondTitle?.[lang]}
          secondaryHtml={informationData?.secondDescription?.[lang]}
        />
      </section>

      <section
        className={styles["statistics-section"]}
        style={{
          backgroundImage: statisticsSectionBackgroundImage
            ? `url(${buildApiUrl(statisticsSectionBackgroundImage)})`
            : "",
        }}
      >
        <div className={styles["statistics-overlay"]}>
          <Container>
            <div
              className={`${styles["statistics-list"]} ${
                lang === "ar" ? styles.rtl : ""
              }`}
              dir={lang === "ar" ? "rtl" : "ltr"}
            >
              {filteredStatistics?.map((post, index) => (
                <div className={styles["statistic-card"]} key={post?.id || index}>
                  <div className={styles["statistic-circle"]}>
                    <h3>{post?.data?.title?.[lang]}</h3>
                    <span>{post?.data?.description?.[lang]}</span>
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </div>
      </section>
      {/* <div className={styles.shapes}>
        <Container>
          <Swiper
            dir={lang === "ar" ? "rtl" : "ltr"}
            key={lang === "ar" ? "rtl" : "ltr"}
            modules={[Navigation, Autoplay]}
            spaceBetween={100}
            slidesPerView={2}
            className={styles.customSswiper}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 100,
              },
              600: { slidesPerView: 2, spaceBetween: 50 },
              768: { slidesPerView: 2, spaceBetween: 50 },
              992: { slidesPerView: 3, spaceBetween: 50 },
              1200: { slidesPerView: 3, spaceBetween: 50 },
            }}
          >
            {filteredStatistics?.map((post, index) => (
              <SwiperSlide key={index}>
                <div className={styles.shape}>
                  <RedBackgroundWithText
                    primaryText={post?.data?.title?.[lang]}
                    secondaryText={post?.data?.description?.[lang]}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Container>
      </div> */}

      <CommonQuestions
        commonQuestionsBackgroundImage={commonQuestionsBackgroundImage}
        filteredQuestions={filteredQuestions}
      />
      {/* <Container>
        <h2 className={styles.customHead}>
          <span className={styles.BlueHoleIcon}>
            <Image
              src={BlueHoleIcon}
              alt=""
              className={styles.BlueHoleIcon}
              width={100}
              height={100}
              priority={true}
            />
          </span>
          <FormattedMessage id="team-members" />
        </h2>
        <TeamMembers teamMembersData={teamMembersData} />
      </Container> */}

      <Footer />
    </>
  );
};

export default AboutPage;
